<div class="tw-flex tw-flex-col tw-gap-1">
  @if (label) {
    <div class="tw-flex tw-gap-1 tw-font-bold tw-text-dt-text-tertiary tw-z-10 tw-text-[12px]">
      <span class="tw-whitespace-nowrap">{{ label }}</span>
      <span *ngIf="isRequired" class="tw-text-sm">*</span>
    </div>
  }
  <div class="tw-relative tw-h-[52px] tw-w-full tw-items-center">
    <div
      #searchWrapper
      cdkOverlayOrigin
      #searchOrigin="cdkOverlayOrigin"
      class="tw-h-full tw-p-2 tw-flex tw-w-full tw-items-center tw-rounded-xl tw-border tw-border-transparent tw-shadow-neuomorphic-inset"
      [ngClass]="{
        'tw-bg-dt-surface-card': isEnabled,
        'tw-bg-dt-surface-disabled tw-opacity-50': !isEnabled,
        'focus-within:tw-border-primary': isEnabled,
        'hover:tw-border-primary': isEnabled,
        'tw-cursor-text': isEnabled,
        'tw-cursor-not-allowed': !isEnabled,
        '!tw-border-dt-border-error': isInvalid() && isEnabled,
      }"
      (click)="onWrapperClick(searchInput)"
    >
      @if (leadingDropdownEnabled) {
        <div
          cdkOverlayOrigin
          #leadingOrigin="cdkOverlayOrigin"
          class="tw-flex tw-h-full tw-w-[160px] tw-flex-shrink-0 tw-items-center tw-gap-1 tw-rounded-xl tw-px-3 tw-whitespace-nowrap border-gradient-neuomorphic tw-bg-dt-neutral-2 tw-shadow-neuomorphic-raised-strong"
          [ngClass]="{
            'tw-cursor-pointer': isEnabled,
            'tw-cursor-not-allowed tw-text-dt-text-secondary': !isEnabled,
          }"
          appKeyboardActivatable
          [appKeyboardActivatableDisabled]="!isEnabled"
          [appKeyboardActivatableExpanded]="leadingExpanded"
          (appKeyboardActivatableActivate)="toggleLeading()"
          (click)="$event.stopPropagation(); isEnabled && toggleLeading()"
        >
          @if (selectedFlag; as flag) {
            <svg class="tw-h-4 tw-w-[22px] tw-flex-shrink-0 tw-overflow-hidden tw-rounded-[3px]">
              <use [attr.xlink:href]="'images/flags.svg#' + flag" />
            </svg>
          }
          <span
            [title]="leadingSelected"
            class="tw-min-w-0 tw-flex-1 tw-truncate tw-form-field-text"
            [ngClass]="{ 'tw-opacity-60': !leadingSelected && leadingPlaceholder && isEnabled }"
          >
            {{ leadingSelected || leadingPlaceholder }}
          </span>
          <icon
            [name]="'down-arrow'"
            [size]="6"
            [currentColor]="'dt-icon-primary'"
            [disableArrowOverride]="true"
            [class.tw-invisible]="!isEnabled"
          ></icon>
        </div>

        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="leadingOrigin"
          [cdkConnectedOverlayOpen]="leadingExpanded && isEnabled"
          [cdkConnectedOverlayPositions]="overlayPositions"
          (overlayOutsideClick)="onLeadingOverlayOutsideClick($event, leadingOrigin)"
        >
          <div
            class="tw-z-30 tw-w-max tw-rounded-lg tw-bg-color-surface-elevated tw-p-2 tw-shadow-lg"
          >
            <div appGlossScroll class="tw-max-h-[256px] tw-overflow-y-auto tw-overscroll-contain">
              @for (item of leadingOptionsWithFlags; track item.label) {
                <div
                  class="tw-flex tw-h-10 tw-cursor-pointer tw-items-center tw-gap-2 tw-whitespace-nowrap tw-rounded-lg tw-px-3 hover:tw-bg-neutral-50"
                  [ngClass]="{ 'tw-bg-neutral-50': item.label === leadingSelected }"
                  (click)="$event.stopPropagation(); selectLeadingOption(item.label)"
                >
                  @if (item.flag) {
                    <svg
                      class="tw-h-4 tw-w-[22px] tw-flex-shrink-0 tw-overflow-hidden tw-rounded-[3px]"
                    >
                      <use [attr.xlink:href]="'images/flags.svg#' + item.flag" />
                    </svg>
                  }
                  {{ item.label }}
                </div>
              }
            </div>
          </div>
        </ng-template>
        <div class="tw-h-6 tw-w-px tw-flex-shrink-0 tw-bg-neutral-200 tw-mx-3"></div>
      }

      <!--      todo: whats the size attr for?-->
      <!--      <input-->
      <!--        class="tw-bg-transparent tw-border-none tw-h-full tw-w-auto tw-flex-none tw-outline-none tw-whitespace-nowrap"-->
      <!--        type="text"-->
      <!--        [formControl]="inputControl"-->
      <!--        [placeholder]="placeholder"-->
      <!--        [attr.size]="getInputSize()"-->
      <!--        (input)="onInput()"-->
      <!--        (blur)="onBlur()"-->
      <!--      />-->

      <input
        #searchInput
        class="tw-bg-transparent tw-border-none tw-h-full tw-flex-1 tw-outline-none tw-whitespace-nowrap tw-form-field-text"
        [class.tw-cursor-text]="isEnabled"
        [ngClass]="{ '!tw-text-dt-text-secondary': !isEnabled }"
        type="text"
        [formControl]="inputControl"
        [placeholder]="placeholder"
        (input)="onInput()"
        (blur)="onBlur()"
      />

      @if (isTagged(inputControl.value)) {
        <ng-container
          *ngTemplateOutlet="tagBadge; context: { $implicit: inputControl.value, extraClass: '' }"
        ></ng-container>
      }

      <div class="tw-flex tw-items-center tw-gap-2 tw-h-full tw-justify-center tw-mr-4">
        @if (isEnabled && inputControl.value) {
          <icon
            class="tw-cursor-pointer"
            [name]="'close'"
            [size]="6"
            [currentColor]="'dt-icon-primary'"
            (click)="clearInput()"
          >
          </icon>
          <div class="tw-flex tw-items-center tw-justify-center tw-h-6 tw-py-[3.5px]">
            <div class="tw-h-full tw-flex tw-border tw-border-color-border-strong"></div>
          </div>
        }
        <icon
          [name]="'down-arrow'"
          [size]="6"
          [currentColor]="'dt-text-secondary'"
          [disableArrowOverride]="true"
          [class.tw-invisible]="!isEnabled"
        ></icon>
      </div>
    </div>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="searchOrigin"
      [cdkConnectedOverlayOpen]="
        dropdown.isExpanded &&
        (filteredOptions.length > 0 || (allowCreate && !!inputControl.value)) &&
        isEnabled
      "
      [cdkConnectedOverlayWidth]="searchWrapper.offsetWidth"
      [cdkConnectedOverlayPositions]="overlayPositions"
      (overlayOutsideClick)="onSearchOverlayOutsideClick($event, searchWrapper)"
    >
      <div class="tw-z-20 tw-w-full tw-bg-color-surface-elevated tw-shadow-lg tw-rounded-lg tw-p-2">
        <ng-container *ngTemplateOutlet="dropdownPanel"></ng-container>
      </div>
    </ng-template>
  </div>
  @if (isInvalid()) {
    <span class="tw-whitespace-nowrap tw-text-dt-text-error tw-text-xs">
      {{ inputControl.value ? ("noMatchingResults" | i18n) : ("inputRequired" | i18n) }}
    </span>
  }
</div>

<ng-template #dropdownPanel>
  <div appGlossScroll class="tw-w-full tw-max-h-[256px] tw-overflow-y-auto tw-overscroll-contain">
    @if (allowCreate && filteredOptions.length === 0 && inputControl.value) {
      <div class="tw-flex tw-items-center tw-justify-between tw-px-2 tw-py-2">
        <span class="tw-text-[14px] tw-text-dt-text-tertiary">{{
          "noCategoriesFound" | i18n
        }}</span>
        <button
          type="button"
          class="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-text-[13px] tw-font-medium tw-text-dt-text-action"
          (click)="createRequested.emit()"
        >
          {{ "createNewCategory" | i18n }}
        </button>
      </div>
    }
    <div
      *ngFor="let option of filteredOptions; trackBy: trackByOption"
      class="tw-flex tw-h-12 tw-w-full tw-cursor-pointer tw-items-center tw-rounded-lg tw-p-2 tw-bg-color-surface-card tw-shadow-dropdown tw-mb-2 last:tw-mb-0 hover:tw-bg-color-surface-elevated"
      (click)="selectOption(option)"
    >
      <span class="tw-flex-1 tw-truncate tw-min-w-0">{{ option }}</span>

      @if (isTagged(option)) {
        <ng-container
          *ngTemplateOutlet="tagBadge; context: { $implicit: option, extraClass: 'tw-ml-2' }"
        ></ng-container>
      }

      @if (isPicker) {
        <icon
          [name]="'add'"
          [size]="4"
          [currentColor]="'dt-icon-primary'"
          class="tw-shrink-0 tw-ml-1"
        ></icon>
      }
    </div>
  </div>
</ng-template>

<ng-template #tagBadge let-value let-extraClass="extraClass">
  @if (isTagged(value)) {
    <span
      class="tw-text-dt-text-headings tw-bg-teal-100 tw-border tw-border-black tw-rounded-md tw-text-xs tw-p-2 tw-whitespace-nowrap tw-flex-shrink-0"
      [ngClass]="extraClass"
    >
      {{ getTag(value) }}
    </span>
  }
</ng-template>
